import { __decorate } from "tslib";
import { html, nothing } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import HelixElement from '../../shared/types/helix-element.js';
import { localized, msg } from '@lit/localize';
import { componentStyles } from '../../shared/styles/component.styles.js';
import { videoOverlayStyles } from './video-overlay.styles.js';
import { SlotController } from '../../shared/controllers/slot.controller.js';
import './video-overlay-button.js';
import '../button/button.js';
import '../icon/icon.js';
import { classMap } from 'lit/directives/class-map.js';
let HlxVideoOverlay = class HlxVideoOverlay extends HelixElement {
    constructor() {
        super(...arguments);
        this.playing = true;
        this.showAutoplayButton = false;
        this.slotController = new SlotController(this, 'video-content', 'overlay-content', 'video-label');
    }
    render() {
        return html `
            <div class="video-overlay-wrapper">
                ${this.slotController.hasSlot('overlay-content') ?
            html `
                        <div class="overlay"></div>
                    `
            : nothing}
                ${this.showAutoplayButton ?
            html `
                        <hlx-button
                            class="video-overlay-button"
                            data-testid="video-overlay-button"
                            @click=${this.handleAutoplay}>
                            <div class="icon-wrapper" slot="icon">
                                <hlx-icon
                                    title=${this.playing ? msg('Pause') : msg('Play')}
                                    name=${this.playing ? 'pause' : 'play-filled'}></hlx-icon>
                                <div class="extra-border"></div>
                            </div>
                        </hlx-button>
                    `
            : nothing}
                <slot name="overlay-content" part="overlay-content" class="overlay-content"></slot>
                <slot name="video-content" part="video-content" class="video-content"></slot>
            </div>
            <slot
                name="video-label"
                class="${classMap({
            'video-label': true,
            'has-video-label': this.slotController.hasSlot('video-label'),
        })}"></slot>
        `;
    }
    handleAutoplay() {
        this.playing = !this.playing;
        this.emit('hlx-autoplay', { play: this.playing });
    }
};
HlxVideoOverlay.styles = [componentStyles, videoOverlayStyles];
__decorate([
    property({ type: Boolean, reflect: true })
], HlxVideoOverlay.prototype, "playing", void 0);
__decorate([
    property({ type: Boolean, reflect: true, attribute: 'show-autoplay-button' })
], HlxVideoOverlay.prototype, "showAutoplayButton", void 0);
HlxVideoOverlay = __decorate([
    customElement('hlx-video-overlay'),
    localized()
], HlxVideoOverlay);
export { HlxVideoOverlay };
//# sourceMappingURL=video-overlay.js.map